/* ReportGeneratorEditorRenderer.js */

"use strict";
const Combobox = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.ComboBox;
const Button = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class ReportGeneratorEditorRenderer {
    constructor(model) {
        this._model = model;
        this._logger = this._model._logger;
        this._rootElem = document.createElement("report-generator-editor-gl");
        this._rootElem.component = this._model;

        this._reportDefinitions = undefined;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Data Export";

        this._reportSelector = new Combobox({
            darkTheme: true,
            placeholder: "Choose a type",
            autoselect: true,
        });

        this._description = document.createElement("p");

        this._runReport = new Button({
            darkTheme: true,
            label: "Run and Download Export",
        });
        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._reportSelector.on(
            "UserValue",
            (this._onReportChanged = this._onReportChanged.bind(this))
        );
        this._runReport.on("UserClick", (this._onUserClick = this._onUserClick.bind(this)));
    }
    _unregisterListeners() {
        this._runReport.removeAllListeners("UserClicked", this._onUserClick);
        this._reportSelector.on("UserValue", this._onReportChanged);
    }
    _retrieveReportDefinitionsModel() {
        return this._model.getReports().then((reports) => {
            this._reportDefinitions = reports;
        });
    }
    _renderReportOptions() {
        let newOpts = [];
        Object.keys(this._reportDefinitions).forEach((name) => {
            newOpts.push({label: name, value: name});
        });
        this._reportSelector.setOptions(newOpts);
        this._onReportChanged();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._reportSelector.shutdown(), this._runReport.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._reportSelector = undefined;
                this._runReport = undefined;
                this._description.remove();
                this._description = undefined;
                this._runReport = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ReportGeneratorEditorRenderer.shutdown() error.");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.append(this._headerElem);
            this._rootElem.append(this._reportSelector.renderer.rootElement);
            this._rootElem.append(this._description);
            this._rootElem.append(this._buttonContainer);
            this._buttonContainer.append(this._runReport.renderer.rootElement);
        }

        return this._retrieveReportDefinitionsModel().then(() => {
            return this._renderReportOptions();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onUserClick() {
        this._model.runReport(this._reportSelector.value);
    }

    _onReportChanged() {
        let reportDescription = this._reportDefinitions[this._reportSelector.value].description;
        this._description.innerText = reportDescription;
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = ReportGeneratorEditorRenderer;
